<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item"><router-link to="/accounting/accounts">{{ $t('general_journal')}}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('account_journal_import')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onSave">
                <i class="fa fa-floppy-o"></i> {{ $t('save') }}
            </button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <select class="form-control form-control-sm">
                                <option value="0">Quickbook</option>
                                <option value="1">System Template</option>
                            </select>
                        </div>
                        <div class="col-sm-10">
                            <input type="file" class="form-control" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ref="file" style="display: none;" @change="onUpload">
                            <button type="button" class="btn btn-success btn-sm" @click="$refs.file.click()">{{$t('choose_excel_file')}}</button>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th>{{$t('no')}}</th>
                                        <th>{{$t('date')}}</th>
                                        <th>{{$t('type')}}</th>
                                        <th>{{$t('account_no')}}</th>
                                        <th>{{$t('account_name')}}</th>
                                        <th>{{$t('partner')}}</th>
                                        <th>{{$t('description')}}</th>
                                        <th>{{$t('ref_no')}}</th>
                                        <th class="text-right">{{$t('debit')}}</th>
                                        <th class="text-right">{{$t('credit')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(ret,index) in journalGroups">
                                        <tr v-for="(line,lindex) in ret.JournalDataLists" :key="index+'-'+lindex">
                                            <td v-if="lindex==0" :rowspan="ret.JournalDataLists.length" style="text-align: center; vertical-align: middle;">
                                                {{ret.TranNo}}
                                            </td>
                                            <td v-if="lindex==0" :rowspan="ret.JournalDataLists.length" style="vertical-align: middle;">{{$format(line.Date,'DD-MM-YYYY')}}</td>
                                            <td v-if="lindex==0" :rowspan="ret.JournalDataLists.length" style="vertical-align: middle;">{{line.TypeNo}}</td>
                                            <td>{{line.AccountNum}}</td>
                                            <td>{{line.AccountName}}</td>
                                            <td>{{line.PartnerName}}</td>
                                            <td>{{line.Description}}</td>
                                            <td>{{line.RefNum}}</td>
                                            <td class="text-right">{{$money(line.Debit)}}</td>
                                            <td class="text-right">{{$money(line.Credit)}}</td>
                                        </tr>
                                        <tr class="table-secondary" :key="index*10000">
                                            <th colspan="8" class="text-right"></th>
                                            <th class="text-right">{{$money(ret.TotalDebit)}}</th>
                                            <th class="text-right">{{$money(ret.TotalCredit)}}</th>
                                        </tr>
                                    </template>
                                </tbody>
                                <tfoot>
                                    <tr class="table-primary">
                                        <th colspan="8" class="text-right">{{$t('balance')}}</th>
                                        <th class="text-right">{{$money(footer.TotalDebit)}}</th>
                                        <th class="text-right">{{$money(footer.TotalCredit)}}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return {
            journalGroups: [],
            header: {
                'Content-Type': 'multipart/form-data'
            },
            typeId: 0,
            footer: {
                TotalDebit: 0,
                TotalCredit: 0
            }
        }
    },
    methods: {
        onUpload(){
            var formData = new FormData();
            formData.append("TypeId", this.typeId);
            formData.append('File', this.$refs.file.files[0]);
            let loading = this.$loading.show();
            this.$api().post('accounting/generaljournal/import', formData, this.header).then(res => {
                if(this.$isValid(res)){
                    this.journalGroups = res.data.Json.JournalGroups;
                    this.calculate();
                }
            }).finally(() => { loading.hide(); });
        },
        onSave(){
            let loading = this.$loading.show();
            this.$api().post('accounting/generaljournal/import/save', this.journalGroups).then(res => {
                if(this.$isValid(res)){
                    this.$router.go(-1);
                }
            }).finally(() => { loading.hide(); });
        },
        calculate(){
            let debits = 0;
            let credits = 0;
            this.journalGroups.forEach(item => {
                debits += Number(item.TotalDebit);
                credits += Number(item.TotalCredit);
            });
            this.footer.TotalDebit = debits;
            this.footer.TotalCredit = credits;
        }
    }
}
</script>